<template>
  <div class="container-fluid p-3"> 
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">PARTE DIARIO DE MULTAS</h5>
 
       
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label>Fecha Inicio:</label>
              <input type="date" v-model="fechaInicio" class="form form-control">
            </div>
          </div>      
          <div class="col-lg-3">
            <div class="form-group">
              <label>Fecha Fin:</label>
              <input type="date" v-model="fechaFin" class="form form-control">
            </div>
          </div>   
          <div class="col-lg-2">
            <label style="color:#FFFFFF">...</label><br>
            <a @click="BuscarFechasOperador(fechaInicio, fechaFin)" class="btn btn-primary"><i class="fa fa-search"></i></a>
          </div>
           
          <div class="col-lg-2">
          <label>Exportar:</label><br>
          <a @click="exportarXls(fechaInicio, fechaFin)" 
          class="btn btn-success">Excel <i class="fa fa-download"></i></a>   
          </div>      
        </div>
         <div class="text-center" v-if="cargando">
          <i class="fa fa-spinner fa-pulse fa-5x"></i>
          <h4 class="mt-2">Cargando Datos...</h4>
        </div>
        <div class="table-responsive mt-3" style="overflow-y:scroll; height:560px;">
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NRO DEPOSITO</small></th>
                <th><small class="font-weight-bold">MONTO BS.</small></th>
                <th><small class="font-weight-bold">MONTO UFV.</small></th>
                <th><small class="font-weight-bold">FECHA DEPÓSITO</small></th>
                
                
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in registros" :key="index">
                <td class="text-center"><small>{{ index + 1 }}</small></td>
                <td>
                  <small>{{ item.per_nombres + " " }}</small>
                  <small>{{ item.per_primer_apellido + " " }}</small>
                  <small v-if="item.per_segundo_apellido">{{ item.per_segundo_apellido }}</small>
                </td>
                <td>
                  <small>{{ item.per_numero_documento }} <br> 
                  </small>
                </td>
                <td class="text-center"><small>{{ item.numero_deposito }}</small><br>
                        <small>{{item.tipo_deposito }}</small>
                </td>
                <td><small>{{ item.valor_multa_bs }}</small></td>
                <td><small>{{ item.valor_multa_ufv }}</small></td>
                <td><small>{{ item.fecha_deposito }}</small></td>
                
 
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import moment from "moment";

const letras = helpers.regex("alpha", /^[a-zA-Z ]*$/);
const numero = helpers.regex("alpha", /^[-1234567890]*$/);

export default {
  components: {
    Loading,
  },
  data() {
    return {
      registros: [],
      resultados: [],
      tipoDocumentos: [],
      nacionalidades: [],
      fechaInicio: new moment().format("YYYY-MM-DD"),
        fechaFin: new moment().format("YYYY-MM-DD"),
      options: [],
      elegido: {
        id_persona: 0,
        per_nombres: '',
        per_primer_apellido: '',
        per_segundo_apellido: '',
        par_tipo_documento: '',
        per_numero_documento: '',
        per_fecha_nacimiento: '',
        par_genero: '',
        par_nacionalidad: '',
        per_telefono: '',
        
      },
      buscar: "",
      filtro: '1',
      cargando: false,
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    filtrar (){
      if(this.filtro=='1'){
        //this.listarDatos();
      }else if(this.filtro=='2'){
        this.listarSancionados();
      }else{
        this.listarNoSancionados();
      } 
    },
    async buscarPersona() {
      // Busqueda general
      try {
        this.resultados = await this.axios.get(`/personas/buscar/${this.buscar}`);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async listarDatos() {
      try {
        this.cargando = true;
        let resultados = await this.axios.get(`/personas/extranjeros`);
        if(resultados.status == 200){
          this.cargando = false;
          this.registros = resultados.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
      }
    },
    async listarSancionados() {
      try {
        this.resultados = await this.axios.get(`/sancionados`);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async listarNoSancionados() {
      try {
        this.resultados = await this.axios.get(`/no_sancionados`);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      if(str!="" && str!=null){
        let arrayFecha = str.split("-");
        return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      }
      else{
        return "";
      }
    },
    showModal(item) {
      let indice = this.registros.indexOf(item);
      let data = this.registros[indice];
      this.elegido = data;
      this.$refs["modalEditar"].show();
    },
    hideModal() {
      this.$refs["modalEditar"].hide();
    },
    ofusca : function (cadena) {
      return window.btoa(cadena);
    },
    async getTipoDocumento() {
      try {
        let res = await this.axios.get(`/getParametros/DOCUMENTO`);
        this.tipoDocumentos = res.data.contenido;        
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getNacionalidades() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios.get(`/parametrosPaises`, config)
          .then((response) => {
            this.nacionalidades = response.data.contenido;
          })
          .catch((error) => {
            console.log('catch: ', error);
          });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async editar (){
      this.cargando = true;
      //revisar
      // this.$v.$touch();
      // if(this.$v.$invalid){
      //   this.cargando = false;
      //   return;
      // }

      try {
        let resultados = await this.axios.put(`/persona`, this.elegido);
        if(resultados.status == 200){
          this.cargando = false;
          this.hideModal();
          this.$swal({
            title: "Información",
            type: "success",
            html: `Modificación correcta.`,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          })
          .then(()=>{
            this.listarDatos();
          });
        }
        
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async listaUfv() {

        let fecha=moment(this.fecha_ufv).format("YYYY-MM-DD")
        
      try { 
          let resultados = await this.axios.get(`/lista_ufv/${fecha}`);
          this.listado_ufv = resultados.data.contenido;
         
                if(this.listado_ufv == undefined || this.listado_ufv == 0 || this.listado_ufv == ''){
            this.$swal({
        title: "Cargar UFVs",
        html: "Porfavor!!!!",
        type: "warning",
     
        confirmButtonColor: "#3085d6",
        confirmButtonText: 'Aceptar'
      })
          }
      }
      catch (error) {
        console.log('catch: ', error);
      }
    },
    async BuscarFechasOperador(fechaInicio, fechaFin) {     
    
     let config = { headers: { token: this.token } };
     //console.log("token",config);
      try {
        this.resultados = await this.axios.get(`/Parte_Diario/${fechaInicio}/${fechaFin}`, config);
        this.registros = this.resultados.data.contenido; 
       //console.log("devuelto:",this.registros);
      } catch (error) {
        console.log(error);
      }      
    },
   crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },

    async exportarXls(fechaInicio, fechaFin){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/ParteDiarioExcel/${fechaInicio}/${fechaFin}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    }
  },
  validations: {
    usuario: {
      direccion: { required, minLength: minLength(6) },
    },
    elegido: {
      per_nombres: { required, letras },
      per_primer_apellido: { required, letras },
      per_segundo_apellido: { letras },
      per_telefono: { numero },
      par_tipo_documento: { required },
      per_numero_documento: { required },
      per_fecha_nacimiento: { required },
      par_genero: { required },
      par_nacionalidad: { required },
      per_email: { email }
    }
  },
  created() {
    //this.listarDatos();
    this.getTipoDocumento();
    this.getNacionalidades();
  },
}
</script>